import { FunctionComponent as F } from "react";
import { useSelector } from 'react-redux';
import { Draggable } from 'react-beautiful-dnd';
import ProtocolTableRow from './ProtocolTableRow';
import { IState } from "../../core/store/store";
import { ProtocolDosingRow } from "@protoplan/types";


interface Props
{
  protocolId: number,
  updateValue: (dosingId: number, value: number, label: keyof ProtocolDosingRow) => Promise<void>;
  rowIndex: number,
  withinBudgetColour: string;
  headings: { Header: string; accessor: string; }[]
}


const DraggableProtocolTableRow: F<Props> = (props: Props) =>
{
  const protocol = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === props.protocolId));
  if(!protocol)
    return <></>;

  return (protocol.edit ?
    <Draggable draggableId={props.rowIndex.toString()} index={props.rowIndex} key={props.rowIndex}>
      {provided => <ProtocolTableRow
        key={props.rowIndex}
        protocolId={props.protocolId}
        rowIndex={props.rowIndex}
        withinBudgetColour={props.withinBudgetColour}
        headers={props.headings}
        updateValue={props.updateValue}
        provided={provided}/>}
    </Draggable> :
    <ProtocolTableRow
      key={props.rowIndex}
      protocolId={props.protocolId}
      rowIndex={props.rowIndex}
      withinBudgetColour={props.withinBudgetColour}
      headers={props.headings}
      updateValue={props.updateValue}/>);
};

export default DraggableProtocolTableRow;
